import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PriorityWorkOfferLabel } from 'shared/models/static-list-data.service';

@Component({
  selector: 'app-priority-work-offer-lookup',
  templateUrl: './priority-work-offer-lookup.component.html',
  styleUrls: ['./priority-work-offer-lookup.component.css']
})
export class PriorityWorkOfferLookupComponent implements OnInit {

  @Input() set resetData(isClear) {
    if (isClear) {
      this.priorityWorkOfferSelected = [];
    }
  }
  @Input() placeholder = 'Priority Label';
  @Input() isdisabled = false;
  @Input() filterObjValue = 'priorityLabel';
  @Input() isMultipleSelected = true;
  @Input() viewType = '';

  @Output() getPriorityWorkOfferObj: EventEmitter<any> = new EventEmitter;


  priorityWorkOfferOptionList = [];
  priorityWorkOfferSelected = [];

  /**
   * @constructor
   * Represents a PriorityLookupComponent.
   */
  constructor() {
  }

  ngOnInit() {
    this.priorityWorkOfferOptionList = PriorityWorkOfferLabel;
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.priorityWorkOfferSelected = (preselected && preselected[this.filterObjValue]) ? preselected[this.filterObjValue] : '';
  }

  onPriorityWorkOfferChange() {
    this.getPriorityWorkOfferObj.emit(this.priorityWorkOfferSelected);
  }

  clearPriorityWorkOffer() {
    this.priorityWorkOfferSelected = [];
    this.getPriorityWorkOfferObj.emit([]);
  }

}
